<template>
  <div v-if="property" class="project-details-sidebar">
    <ul class="project-info-list">

      <li class="d-flex align-items-center mb-3 p-4 rounded" v-if="property.catalog_id">
        <span class="ti-tag icon-sm color-secondary d-block mr-3"></span>
        <div class="d-block">
          <h5 class="mb-0">{{ $t('property_detail.property.catalog_id') }}</h5>
          <p>{{ property.catalog_id }}</p>
        </div>
      </li>

      <li class="d-flex align-items-center mb-3 p-4 rounded" v-if="property.developer">
        <span class="ti-home icon-sm color-secondary d-block mr-3"></span>
        <div class="d-block">
          <h5 class="mb-0">{{ $t('property_detail.property.developer') }}</h5>
          <p>{{ property.developer }}</p>
        </div>
      </li>

      <li class="d-flex align-items-center mb-3 p-4 rounded" v-if="property.purpose_label">
        <span class="ti-flag-alt icon-sm color-secondary d-block mr-3"></span>
        <div class="d-block">
          <h5 class="mb-0">{{ $t('property_detail.property.purpose') }}</h5>
          <p>{{ property.purpose_label }}</p>
        </div>
      </li>

      <li class="d-flex align-items-center mb-3 p-4 rounded" v-if="property.layout_type_label">
        <span class="ti-layout icon-sm color-secondary d-block mr-3"></span>
        <div class="d-block">
          <h5 class="mb-0">{{ $t('property_detail.property.layout_type_label') }}</h5>
          <p>{{ property.layout_type_label }}</p>
        </div>
      </li>

      <li class="d-flex align-items-center mb-3 p-4 rounded" v-if="property.status_label">
        <span class="ti-check icon-sm color-secondary d-block mr-3"></span>
        <div class="d-block">
          <h5 class="mb-0">{{ $t('property_detail.property.status_label') }}</h5>
          <p>{{ property.status_label }}</p>
        </div>
      </li>

      <li class="d-flex align-items-center mb-3 p-4 rounded" v-if="property.mortgage_available">
        <span class="ti-credit-card icon-sm color-secondary d-block mr-3"></span>
        <div class="d-block">
          <h5 class="mb-0">{{ $t('property_detail.property.mortgage_available') }}</h5>
          <p>{{ $t('property_detail.property.mortgage_available') }}</p>
        </div>
      </li>

      <li class="d-flex align-items-center mb-3 p-4 rounded" v-if="property.citizenship_available">
        <span class="ti-id-badge icon-sm color-secondary d-block mr-3"></span>
        <div class="d-block">
          <h5 class="mb-0">{{ $t('property_detail.property.citizenship_available') }}</h5>
          <p>{{ $t('property_detail.property.citizenship_available') }}</p>
        </div>
      </li>

    </ul>
  </div>

  <div v-else class="text-center text-muted mt-4">
    {{ $t('property_detail.property.loading') }}
  </div>
</template>


<script setup>
import { ref } from 'vue'

const props = defineProps({
  property: {
    type: Object,
    required: true
  }
})

const leadFormVisible = ref(false)

const showLeadForm = () => {
  leadFormVisible.value = true
}

const closeLeadForm = () => {
  leadFormVisible.value = false
}
</script>